import { useLocalStorage } from "@vueuse/core";
export const useDeveloperMode = () => {
    const developerMode = useLocalStorage("extole.me.developerMode", false);
    return {
        developerMode,
    };
};
